import { Record, RecordOf } from 'immutable';
import { constants } from './geofenceActions';
import { Geofence } from '../../types/types';

const { 
    FETCH_GEOFENCES_REQUEST,
    FETCH_GEOFENCES_SUCCESS,
    FETCH_GEOFENCES_FAILURE,
} = constants;

interface GeofenceState {
    geofences: Geofence[] | null;
    isFetchingGeofences: boolean;
    error: string | null;
}
type GeofenceStateRecord = RecordOf<GeofenceState>
type GeofenceAction =
    | { 
        type: 'FETCH_GEOFENCES_REQUEST'; 
    } | {
        type: 'FETCH_GEOFENCES_SUCCESS';
        payload: { data: Geofence[] };
    } | { 
        type: 'FETCH_GEOFENCES_FAILURE'; 
        payload: string; 
    };

const InitialState = Record<GeofenceState>({
    geofences: null,
    isFetchingGeofences: false,
    error: null,
});
const geofenceInitialState: GeofenceStateRecord = new InitialState();


/**
 * Geofence reducer
 * @param state the initial or existing state
 * @param action consisting of payload and type
 */
function geofenceReducer(
    state: GeofenceStateRecord = geofenceInitialState, 
    action: GeofenceAction,
) {
    if (!(state instanceof InitialState)) {
        state = geofenceInitialState.mergeDeep(state) as GeofenceStateRecord; 
    }

    switch (action.type) {
        case FETCH_GEOFENCES_REQUEST:
            return state.set('error', null)
                .set('isFetchingGeofences', true);
        case FETCH_GEOFENCES_SUCCESS:
            return state.set('error', null)
                .set('isFetchingGeofences', false)
                .set('geofences', action.payload.data);
        case FETCH_GEOFENCES_FAILURE:
            return state.set('error', action.payload)
                .set('isFetchingGeofences', false);
        default:
            return state;
    }
}

export {
    geofenceReducer,
    geofenceInitialState,
};
